export const ContentKeys = [
  'sports', 'muscleRegime',  'muscleGroups',  'secondaryMuscleGroups',
  'fitnessActivity', 'motorSkills', 'suitableForHealthIssues', 'equipment',
  'difficultyLevel', 'goals', 'healthIssues',
] as const;

export const NutritionKeys = [
  'micronutrient','goodFor','diet' , 'category', 
  'timePreparation', 'mealTypes', 
  'glycemicIndexRange', 'glycemicLoadRange', 'durationInWeeks', 'counterProductiveFor'
] as const;

export const SwitchKeys = [
  "archived", "showMFWOriginals", "showORGOriginals", "showPublic", "showPremium", "isLockedContentDisplayed"
] as const;

export const allKeys = [...ContentKeys, ...NutritionKeys] as const;

export type ContentKey = typeof ContentKeys[number];
export type NutritionKey = typeof NutritionKeys[number];
export type SwitchKey = typeof SwitchKeys[number];
export type AllContentKey = typeof allKeys[number];
export type ContentFilter = Partial<Record<AllContentKey | SwitchKey, string | string[]>>;